import { api } from "../../api/apiSlice";

export const employeesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Query-arg cache means every distinct search string gets its own cache
    // entry; fine here since result sets are small and short-lived.
    searchEmployees: builder.query({
      query: (query) => ({ url: "/employees/search", params: { query } }),
      providesTags: ["Employees"],
    }),
  }),
  overrideExisting: false,
});

export const { useLazySearchEmployeesQuery } = employeesApi;
